<template>
  <v-container fluid class="py-0 px-2">
    <v-text-field
      v-model="search"
      background-color="colorSearchSettings"
      clearable
      :append-icon="mdiMagnify"
      :label="$t('label.search')"
      hide-details
    ></v-text-field>
    <div style="min-height: 1px"></div>
    <v-data-table
      :headers="headers"
      :items="tableData"
      item-key="id"
      :height="$store.state.windowSize.y - 150"
      :search="search"
      fixed-header
      must-sort
      disable-pagination
      hide-default-footer
      class="tableCursor"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.sourceName }}</td>
          <td>{{ item.action }}</td>
          <td>{{ item.email }}</td>
          <td
            v-if="$store.state.auth.userSettings.accMessages.update"
            class="px-2 tableSelectCursor"
            @click="((dialogEdit = true), (message = { ...item }))"
          >
            <v-icon>{{ mdiPen }}</v-icon>
          </td>
          <td v-else></td>
        </tr>
      </template>
    </v-data-table>
    <v-row>
      <v-col cols="3">
        <v-btn v-if="$store.state.auth.userSettings.accMessages.write" block color="colorNew" @click="dataNew">
          {{ $t('label.addNew') }}
        </v-btn>
      </v-col>
    </v-row>
    <!----------DIALOGS------------------------------>
    <v-dialog v-model="dialogEdit" persistent width="80%">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $tc('label.notification', 2) }}
          <v-spacer />
          <v-icon large @click="dialogEdit = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-row>
            <v-col cols="8">
              <v-form v-model="validForm" ref="messageForm">
                <v-row>
                  <v-col cols="6">
                    <v-select
                      v-model="message.sourceID"
                      :label="$tc('label.planningGroup')"
                      :items="listEmployeeGroups"
                      append-icon
                      item-text="name"
                      item-value="id"
                      hide-details
                      autocomplete="off"
                      :rules="[ruleRequired]"
                      @change="filterActions"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="message.action"
                      :label="$t('label.action')"
                      :items="listActions"
                      append-icon
                      item-text="text"
                      item-value="value"
                      hide-details
                      :rules="[ruleRequired]"
                      autocomplete="off"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-2" />
                <v-row>
                  <v-col cols="2">
                    <v-checkbox v-model="message.email" :label="$t('label.email')" hide-details />
                  </v-col>
                  <v-col cols="10">
                    <v-text-field v-model="message.emailSubject" :label="$t('label.subject')" hide-details />
                    <v-textarea v-model="message.emailBody" :label="$t('label.message')" rows="8" hide-details />
                  </v-col>
                </v-row>
                <!-- v-divider class="my-2" />
                <v-row>
                  <v-col cols="2">
                    <v-checkbox v-model="message.sms" label="SMS" hide-details />
                  </v-col>
                  <v-col cols="10">
                    <v-text-field v-model="message.smsMessage" label="Zpráva" hide-details />
                  </v-col>
                </v-row -->
              </v-form>
            </v-col>
            <v-col cols="4">
              <v-row>
                <v-col class="pt-1 pb-0">
                  <b> {{ $tc('label.value') }}</b>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="6">{{ $tc('label.employee') }} {{ String($t('label.name')).toLowerCase() }}</v-col>
                <v-col class="py-0" cols="6"><span v-text="`{{ .EmpName }}`" /></v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="6">{{ $tc('label.employee') }} {{ String($t('label.surname')).toLowerCase() }}</v-col>
                <v-col class="py-0" cols="6"><span v-text="`{{ .EmpSurname }}`" /></v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="6">{{ $tc('label.employee') }} {{ $t('label.email') }}</v-col>
                <v-col class="py-0" cols="6"><span v-text="`{{ .EmpEmail }}`" /></v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="6">{{ $tc('label.employee') }} {{ String($t('label.phone')).toLowerCase() }}</v-col>
                <v-col class="py-0" cols="6"><span v-text="`{{ .EmpPhone }}`" /></v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="6">{{ $tc('label.employee') }} {{ String($t('label.mobile')).toLowerCase() }}</v-col>
                <v-col class="py-0" cols="6"><span v-text="`{{ .EmpMobile }}`" /></v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="6">{{ $tc('label.employee') }} {{ $tc('label.department', 2).toLowerCase() }}</v-col>
                <v-col class="py-0" cols="6"><span v-text="`{{ .EmpDepartment }}`" /></v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="6">{{ $tc('label.visitor') }} {{ String($t('label.name')).toLowerCase() }}</v-col>
                <v-col class="py-0" cols="6"><span v-text="`{{ .VisName }}`" /></v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="6">{{ $tc('label.visitor') }} {{ String($t('label.surname')).toLowerCase() }}</v-col>
                <v-col class="py-0" cols="6"><span v-text="`{{ .VisSurname }}`" /></v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="6">{{ $tc('label.visitor') }} {{ String($t('label.email')).toLowerCase() }}</v-col>
                <v-col class="py-0" cols="6"><span v-text="`{{ .VisEmail }}`" /></v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="6">{{ $tc('label.visitor') }} {{ String($t('label.phone')).toLowerCase() }}</v-col>
                <v-col class="py-0" cols="6"><span v-text="`{{ .VisPhone }}`" /></v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="6">{{ $tc('label.visitor') }} {{ $tc('label.company').toLowerCase() }}</v-col>
                <v-col class="py-0" cols="6"><span v-text="`{{ .VisCompany }}`" /></v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="6">{{ $tc('label.visitor') }} {{ $tc('label.car').toLowerCase() }}</v-col>
                <v-col class="py-0" cols="6"><span v-text="`{{ .VisCar }}`" /></v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="6">{{ $tc('label.visitor') }} {{ $tc('label.note').toLowerCase() }}</v-col>
                <v-col class="py-0" cols="6"><span v-text="`{{ .VisNote }}`" /></v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="6">{{ $tc('label.area') }} {{ String($t('label.itemName')).toLowerCase() }}</v-col>
                <v-col class="py-0" cols="6"><span v-text="`{{ .VisArea }}`" /></v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="6">{{ $tc('label.approval') }} {{ String($t('label.status')).toLowerCase() }}</v-col>
                <v-col class="py-0" cols="6"><span v-text="`{{ .VisApproval }}`" /></v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="6">{{ $tc('label.approval') }} URL</v-col>
                <v-col class="py-0" cols="6"><span v-text="`{{ .ApprovalURL }}`" /></v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-btn v-if="message.id && $store.state.auth.userSettings.accMessages.delete" color="colorDelete" @click="dialogDelete = true">
            {{ $tc('btn.delete') }}
          </v-btn>
          <v-btn @click="testTemplateApproval">TEST</v-btn>
          <v-spacer />
          <v-btn color="colorSave" @click="dataSave">{{ $tc('btn.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogTest" width="60%">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $tc('label.notification', 2) }}
          <v-spacer />
          <v-icon large @click="dialogTest = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-divider />
          <pre>{{ testResponse.emailSubject }}</pre>
          <v-divider />
          <pre>{{ testResponse.emailBody }}</pre>
          <v-divider />
        </v-card-text>
      </v-card>
    </v-dialog>

    <DialogConfirmDelete
      :header="$t('label.delete')"
      :body="`${$t('msg.confirmDelete')}?`"
      :openDialog.sync="dialogDelete"
      v-on:confirm="dataDelete"
    />
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import DialogConfirmDelete from '@/components/DialogConfirmDelete.vue';

import { mdiMagnify, mdiPen, mdiClose, mdiEarth } from '@mdi/js';

export default Vue.extend({
  name: 'SettingsMessages',
  components: { DialogConfirmDelete },
  data: () => ({
    tableData: [],
    dialogEdit: false,
    dialogDelete: false,
    dialogTest: false,
    validForm: false,
    search: '',
    message: {
      id: 0,
      source: '',
      action: '',
      email: false,
      sms: false,
      push: false,
      emailSubject: '',
      emailBody: '',
      smsMessage: '',
      pushMessage: '',
      sourceID: 0,
    },
    testResponse: {
      emailSubject: '',
      emailBody: '',
    },
    listEmployeeGroups: [],
    mdiMagnify: mdiMagnify,
    mdiPen: mdiPen,
    mdiClose: mdiClose,
    mdiEarth: mdiEarth,
  }),
  computed: {
    ruleRequired() {
      return (v: any) => !!v || this.$i18n.t('msg.fieldIsMandatory');
    },
    headers: function () {
      return [
        { text: this.$i18n.tc('label.group'), value: 'sourceName' },
        { text: this.$i18n.t('label.action'), value: 'Action' },
        { text: this.$i18n.t('label.email'), value: 'email' },
        // { text: 'SMS', value: 'sms' },
        { sortable: false, width: '48px' },
      ];
    },
    listActions: function () {
      return [
        {
          text: this.$i18n.tc('label.visitor') + ' ' + this.$i18n.t('label.for') + ' ' + this.$i18n.tc('label.approval').toLowerCase(),
          value: 'authorization',
          disabled: false,
        },
        { text: this.$i18n.tc('label.visitor') + ' ' + this.$i18n.tc('label.approval', 3), value: 'approval', disabled: false },
      ];
    },
  },
  mounted() {
    this.listEmployeeGroupsLoad();
    this.dataLoad();
  },
  methods: {
    dataLoad() {
      axios
        .get('/api/v1/message')
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    dataNew() {
      const defaults: any = this.$options;
      this.message = { ...defaults.data().message };
      this.dialogEdit = true;
      this.$nextTick(function () {
        const form: any = this.$refs.messageForm;
        form.validate();
      });
    },
    testTemplateApproval() {
      let apiAddress = '';
      this.message.action === 'approval'
        ? (apiAddress = '/api/v1/templateapproval/test')
        : (apiAddress = '/api/v1/templateauthorisation/test');

      axios
        .post(apiAddress, this.message)
        .then((response) => {
          this.testResponse = response.data;
          this.dialogTest = true;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    dataSave() {
      const form: any = this.$refs.messageForm;
      if (form.validate() !== true) {
        this.$store.commit('globalMessage', this.$i18n.t('msg.formNotValid'));
      } else {
        if (this.message.id === 0) {
          this.message.source = 'employeeGroups';
          axios
            .post('/api/v1/message', this.message)
            .then(() => {
              this.dataLoad();
              this.dialogEdit = false;
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        } else {
          axios
            .put('/api/v1/message', this.message)
            .then(() => {
              this.dataLoad();
              this.dialogEdit = false;
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        }
      }
    },
    dataDelete() {
      axios
        .delete(`/api/v1/message/${this.message.id}`)
        .then(() => {
          this.dataLoad();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
      this.dialogEdit = false;
      this.dialogDelete = false;
    },
    listEmployeeGroupsLoad() {
      axios
        .get('/api/v1/employeegroup')
        .then((response) => {
          const global = response.data // Zmaz globalni skupinu pro planovani
            .map((item: any) => {
              return item.id;
            })
            .indexOf(0);
          response.data.splice(global, 1);
          this.listEmployeeGroups = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    filterActions(item: any) {
      this.message.action = '';
      this.listActions.forEach((action) => {
        action.disabled = false;
      });
      for (const record of this.tableData) {
        if (record.source === 'employeeGroups' && record.sourceID === item) {
          for (const action of this.listActions) {
            if (action.value === record.action) {
              action.disabled = true;
            }
          }
        }
      }
    },
  },
});
</script>
